import { render } from "./bell.svg?vue&type=template&id=d0eff08e"
const script = {}

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__